import type { ActionMessage, UnconfirmedActionMessage } from "@engine/core";
import { Action } from "@engine/round/actions";
import { sortByProperty } from "@lib/utils/sortByProperty";

export type ActionLogItem =
  | UnconfirmedActionMessage
  | UnconfirmedActionMessage[];

function actionsAreGroupable(a: Action, b: Action): boolean {
  switch (a.type) {
    case "EVALUATION_MVF_CHANGE":
      return (
        a.type === b.type &&
        // a.evaluableId === b.evaluableId &&
        a.evaluatorId === b.evaluatorId
      );
    case "EVALUATION_NOTES_CHANGE":
    case "EVALUATION_FEEDBACK_CHANGE":
      return (
        a.type === b.type &&
        a.evaluableId === b.evaluableId &&
        a.memberId === b.memberId
      );
    case "ADD_PROPOSAL":
      return true;
    case "ADD_OR_UPDATE_PROPOSAL_FORM_FIELD":
      return a.type === b.type && a.proposalFormId === b.proposalFormId;
    case "PROPOSAL_FIELD_RESPONSE_CHANGE":
      return a.type === b.type && a.proposalId === b.proposalId;
    case "INCREMENTAL_EVALS_PUSH":
      return a.type === b.type && a.evaluableId === b.evaluableId;
    default:
      return false;
  }
}

export function getEventLogItems(
  actionMessages: ActionMessage[],
): ActionLogItem[] {
  actionMessages.sort(sortByProperty("timestamp"));

  const result: ActionLogItem[] = [];
  let currentGroup: ActionMessage[] = [];

  for (const actionMessage of actionMessages) {
    const action = actionMessage.payload;
    const userId = actionMessage.actingAsUserId;

    if (currentGroup.length > 0) {
      const groupHead = currentGroup[0];
      const groupable =
        groupHead.actingAsUserId === userId &&
        actionsAreGroupable(groupHead.payload, action);
      if (groupable) {
        currentGroup.push(actionMessage);
      } else {
        result.push(currentGroup.length > 1 ? currentGroup : currentGroup[0]);
        currentGroup = [actionMessage];
      }
    } else {
      currentGroup = [actionMessage];
    }
  }

  if (currentGroup.length > 0) {
    result.push(currentGroup.length > 1 ? currentGroup : currentGroup[0]);
  }

  return result;
}
